import RootErrorBoundary from './RootErrorBoundary'
export default RootErrorBoundary



// WEBPACK FOOTER //
// ./src/atoms/RootErrorBoundary/index.js